<template>
    <div>
        <div class="table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>
                            <button @click="agregarItem" class="btn-success" type="button"><i class="fa fa-plus"></i></button>
                        </th>
                        <th>Código</th>
                        <th>Serie</th>
                        <th>Descripción</th>
                        <th>Cantidad</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in modelValue" :key="index">
                        <td>
                            <button @click="editarItem(index)" class="btn-info btn--text" type="button"><i class="fa fa-edit"></i></button>
                        </td>
                        <td>{{ item.codigo }}</td>
                        <td>{{ item.serie }}</td>
                        <td :tooltip="item.descripcion!==''?item.descripcion:'Seleccione...'">{{ item.descripcion }}</td>
                        <td>{{ item.cantidad }}</td>
                        <td>
                            <button @click="eliminarItem(index)" class="btn-danger btn--text" type="button"><i class="fa fa-trash"></i></button>
                        </td>
                    </tr>
                    <tr v-show="modelValue.length === 0">
                        <td colspan="6">
                            <strong>No se ha agregado ítems.</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <modal name="itemGuiaRemision" width="60%" height="auto" scrollable>
            <item-guia-remision @cancelar="cancelarItem" :clickToClose="false" @input="inputItem" v-model="selectedItem"></item-guia-remision>
        </modal>
        <modal name="itemsComprobante" width="70%" height="auto" scrollable>
            <items-comprobante :idItem="idItem" @cancelar="$modal.hide('itemsComprobante')" v-model="modelValue" @input="inputItems" :idComprobante="idComprobante"></items-comprobante>
        </modal>
    </div>
</template>

<script>
export default {
    props : {
        value : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        idComprobante : {
            type : String,
            required : false,
            default : ''
        }
    },
    data : function () {
        return {
            modelValue : this.value,
            currentIndex : -1,
            selectedItem : null,
            esNuevoItem : false,
            idItem : ''
        }
    },
    methods : {
        agregarItem : function () {
            if (this.idComprobante !== '') 
            {
                this.idItem = '';
                this.$modal.show('itemsComprobante');
            }
            else {
                this.esNuevoItem = true;
                let nuevoItem = {
                    codigo : '',
                    descripcion : '',
                    cantidad : 1,
                    serie : '',
                    cantidad_gr : 0
                };
                this.modelValue.push(nuevoItem);
                this.selectedItem = JSON.parse(JSON.stringify(nuevoItem));
                this.$modal.show('itemGuiaRemision');
            }
        },
        inputItems : function (items) {
            this.modelValue = items;
            this.$emit('input', this.modelValue);
            this.$modal.hide('itemsComprobante');
        },
        inputItem : function (item) {
            this.modelValue.splice(this.currentIndex, 1, item);
            this.$emit('input', this.modelValue);
            this.selectedItem = null;
            this.currentIndex = -1;
            this.$modal.hide('itemGuiaRemision');
        },
        eliminarItem : function (index) {
            let that = this;
            swal({
                title: '¿Desear quitar este item?',
                text: "Esta acción requiere de confirmación.",
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Quitar',
                cancelButtonText : 'No'
            }).then((result) => {
                if (result.value)
                    that.modelValue.splice(index, 1);                 
            });
        },
        editarItem : function (index) {
            this.currentIndex = index;
            if (this.idComprobante === '')
            {
                this.selectedItem = JSON.parse(JSON.stringify(this.modelValue[index]));
                this.$modal.show('itemGuiaRemision');
            }
            else 
            {
                this.idItem = this.modelValue[index].codigo;
                this.$modal.show('itemsComprobante');
            }
        },
        cancelarItem : function () {
            if (this.esNuevoItem)
                this.modelValue.splice(this.currentIndex, 1);
            this.currentIndex = -1;
            this.selectedItem = null;
            this.$modal.hide('itemGuiaRemision');
        }
    },
    watch : {
        value : function (value) {
            this.modelValue = value;
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/TablaItemGuiaRemision.vue